import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function updateAccessRulesAPI(id, accessRule) {
  const url = `${AWS_API_URL}/2n/access-rules/${id}`;
  const source = (accessRule && accessRule.accessRule) || accessRule || {};

  return putRequest(url, {
    data: {
      name: source.name,
      zoneId: source.zoneId,
      groupId: source.groupId,
      timeProfileId: source.timeProfileId,
    },
  },
  await authorize());
}
